export function isTextEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1;
}
